var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFuerAlleSilikonGeeignet = function SvgFuerAlleSilikonGeeignet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Fuer_alle_Silikon_geeignet_svg__Ebene_2",
    viewBox: "0 0 98.66 87.37"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Fuer_alle_Silikon_geeignet_svg__cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:3.64px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fuer_alle_Silikon_geeignet_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.06 49.37 60.34 84.98 2.68 51.21 39.05 2.74zM95.72 82.67l-31.15-2.73 18.67-24.87z",
    className: "Fuer_alle_Silikon_geeignet_svg__cls-1"
  }))));
};
export default SvgFuerAlleSilikonGeeignet;